module.exports = __webpack_public_path__ + "static/media/Twitter.aa6d90be.png";